import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const NavBarElement = styled(Box)({
	margin: 'auto',
	width: '250px',
	paddingTop: 14,
});
